import arrayUtilities from "./arrayUtilities";
import stringHelpers from "./stringHelpers";

const hasRemainingFilters = filters => Object.values(filters).some(value => !stringHelpers.isNullOrEmpty(value) || !arrayUtilities.isNullOrEmpty(value))

export default {
    hasRemainingFilters,

    applyMultiSelection(previousFilters, label, selectedIds, allItems) {
        const updatedFilters = { ...previousFilters }
        if (!arrayUtilities.isNullOrEmpty(selectedIds)) {
            if (selectedIds.length === 1) {
                const selectedItem = allItems.find(item => item.id === selectedIds[0])
                if (selectedItem !== undefined) {
                    updatedFilters[label] = selectedItem.name
                }
            } else {
                updatedFilters[label] = allItems.filter(item => selectedIds.includes(item.id))
            }
        } else {
            delete updatedFilters[label]
        }
        return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
    },

    keepMultiSelectionItems(previousFilters, label, remainingIds) {
        const updatedFilters = { ...previousFilters }
        const remainingItems = previousFilters[label].filter(item => remainingIds.includes(item.id))
        if (arrayUtilities.isNullOrEmpty(remainingItems)) {
            delete updatedFilters[label]
        } else if (remainingItems.length === 1) {
            updatedFilters[label] = remainingItems[0].name
        } else {
            updatedFilters[label] = remainingItems
        }
        return hasRemainingFilters(updatedFilters) ? updatedFilters : null
    }
}
